export default function AnchorSlice ({ data }) {
  const anchorSlug = data.anchorSlug.current

  return (
    <div id={anchorSlug} className='w-[100px] bg-transparent pointer-events-none h-[0px] pt-[4rem] mt-[-4rem]' />
  )
}
